import React from 'react'

export default function CVBuilder() {
  return (
    <div>CVBuilder</div>
  )
}
